import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getGenderOption } from './helpers'

import { dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'

import { GENDER_OPTION_FEMALES, GENDER_OPTION_MALES } from '../../../../../ReusableFormFields/GenderFields/fields'

const GenderSectionPreview = () => {
  const { t } = useTranslation()

  const targeting = useSelector(dv360TargetingSelector)

  const genderType = getGenderOption(targeting)

  if (genderType === GENDER_OPTION_MALES) {
    return <p>{t('Gender: Male')}</p>
  } else if (genderType === GENDER_OPTION_FEMALES) {
    return <p>{t('Gender: Female')}</p>
  } else {
    return <p>{t('Gender: All')}</p>
  }
}

export default GenderSectionPreview
